import lazyLoading from './lazyLoading'

export default {
  name: 'Contracts',
  path: '/contracts',
  meta: {
    auth: true,
    icon: 'fa-briefcase',
    link: 'contracts/index.vue'
  },
  component: lazyLoading('contracts', true)
  // children : []
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/contracts.js